import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

const getInitialPMXDeliveriesSort = () => {
    const saved = localStorage.getItem('pmxDeliveriesSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 25 (PMX Deliveries default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.pmxDeliveries, 25);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the PMX deliveries slice.
 *
 * Key state values:
 * - deliveries: Array of delivery objects for the grid
 * - filterForm: Search form field values
 * - refreshPmxDeliveries: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    deliveries: [],
    filterForm: {
        skuId: '',
        action: '',
        status: '',
    },
    actionOptions: [
        { value: 'CREATE', label: 'Create' },
        { value: 'UPDATE', label: 'Update' },
        { value: 'DELETE', label: 'Delete' },
    ],
    statusOptions: [
        { value: 'READY', label: 'Ready' },
        { value: 'COMPLETE', label: 'Complete' },
        { value: 'ERROR', label: 'Error' },
        { value: 'SKIPPED', label: 'Skipped' },
        { value: 'HOLD', label: 'Hold' },
        { value: 'IN_PROGRESS', label: 'In Progress' },
        { value: 'REPROCESS', label: 'Reprocess' },
    ],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    pmxDeliveriesRange: getInitialPaginationRange(initialItemsPerPage),
    pmxDeliveriesSort: getInitialPMXDeliveriesSort(),
    defaultFilterRange: getInitialPaginationRange(initialItemsPerPage),
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshPmxDeliveries: false,
};

export function pmxDeliveries(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_PMX_DELIVERIES: {
            // Persist sort preference to localStorage
            if (payload.pmxDeliveriesSort) {
                localStorage.setItem('pmxDeliveriesSort', JSON.stringify(payload.pmxDeliveriesSort));
            }
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.pmxDeliveries, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_PMX_DELIVERIES_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_PMX_DELIVERIES: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                {
                    ...initialState,
                    pmxDeliveriesSort: state.pmxDeliveriesSort,
                },
                ['pmxDeliveriesRange', 'defaultFilterRange']
            );
        }
        default:
            return state;
    }
}
